// extracted by mini-css-extract-plugin
module.exports = {"chevron":"mobile-nav-item_chevron__Inz3G"};